import {
    ClientSoftwareResponse,
    ClientSoftwareUpdateRequest,
} from '@kcftech/prometheus-client';
import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { NoValue } from 'components/no_value/NoValue';
import { useNotificationContext } from 'contexts/NotificationContext';
import { sdClient } from 'contexts/SDKClientContext';

function validateDescription(value: string | undefined) {
    if (value && value.length > 256) {
        return `Description must be 256 characters or fewer (currently ${value.length})`;
    }
    return undefined;
}

export type ClientSoftwareDescriptionCellProps = Readonly<{
    rowData: ClientSoftwareResponse;
    onChange: () => void;
}>;

export function ClientSoftwareDescriptionCell({
    rowData,
    onChange,
}: ClientSoftwareDescriptionCellProps) {
    const { showToast } = useNotificationContext();

    const onSave = async (newDescription: string | undefined) => {
        try {
            await sdClient.updateClientSoftware({
                clientSoftwareId: rowData.Id,
                body: new ClientSoftwareUpdateRequest({
                    Description: newDescription ?? undefined,
                }),
            });
            onChange();
            showToast({
                type: 'success',
                content: 'Successfully updated description.',
            });
        } catch {
            return 'Unable to save description';
        }
        return undefined;
    };

    return (
        <TextInlineEditor
            onConfirm={onSave}
            value={rowData.Description ?? ''}
            validate={validateDescription}
            renderValue={(v) => (v ? <>{v}</> : <NoValue />)}
        />
    );
}
